/**
 * StatusBadge.tsx — colour-coded status pill for a health source/item.
 *
 * Maps SourceStatus → colour: ok=green, degraded=amber, down=red, and
 * unknown=GREY (a distinct neutral, NOT red) so a timed-out / no-signal source
 * never reads as a known fault. Colour is paired with a text label (i18n) so
 * status is never conveyed by colour alone (WCAG 1.4.1 Use of Color).
 *
 */

import { useTranslation } from 'react-i18next';
import type { SourceStatus } from '../api/types';
import { Badge } from './Badge';

export interface StatusBadgeProps {
  status: SourceStatus;
  className?: string;
}

export const StatusBadge = ({ status, className = '' }: StatusBadgeProps) => {
  const { t } = useTranslation();
  const label = t(`status.${status}`);
  return (
    <Badge tone={status} data-testid="status-badge" data-status={status} className={className}>
      {label}
    </Badge>
  );
};
